import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import type { LeadTag } from "@/types/lead";

interface LeadTagBadgeProps {
  tag: LeadTag;
  onRemove?: () => void;
  size?: "sm" | "md";
}

export function LeadTagBadge({ tag, onRemove, size = "md" }: LeadTagBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full text-white font-medium",
        tag.color,
        size === "sm" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs"
      )}
    >
      {tag.name}
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="hover:bg-white/20 rounded-full p-0.5 transition-colors"
        >
          <X className={cn(size === "sm" ? "w-2.5 h-2.5" : "w-3 h-3")} />
        </button>
      )}
    </span>
  );
}
